export default __webpack_public_path__ + "static/media/avi.d9f05582.png";